import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

import { Component, OnInit } from "@angular/core";

import { EditMarkData } from "src/app/models/edit-mark-data";
import { SettingsService } from "src/app/services/settings.service";
import { EditType } from "src/app/models/types";

@Component({
  selector: "app-edit-mark",
  templateUrl: "./edit-mark.component.html",
  styleUrls: ["./edit-mark.component.scss"],
})
export class EditMarkComponent implements OnInit {
  mark!: EditMarkData;
  timeOffset!: string;
  editType!: EditType;
  dateForTime: Date | null = null; // Для редактирования времени
  hasFinish: boolean = false;
  markTime!: string;

  constructor(
    public appSettings: SettingsService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig
  ) { }

  ngOnInit() {
    const { mark, timeOffset, editType, hasFinish } =
      this.dynamicDialogConfig.data;
    this.timeOffset = timeOffset;
    this.editType = editType;
    this.hasFinish = hasFinish;

    if (this.editType == "edit") {
      mark.markDate = this.getConvertedDate(mark.markTime, this.timeOffset);
      const markDate: Date = mark.markDate;
      this.markTime = markDate.toString().split(" ")[4];
    }

    this.mark = mark;
  }

  save() {
    this.mark.markDate.setHours(Number(this.markTime.split(":")[0]));
    this.mark.markDate.setMinutes(Number(this.markTime.split(":")[1]));
    this.mark.markDate.setSeconds(Number(this.markTime.split(":")[2]));
    this.mark.markDate = this.getOriginalDate(
      this.mark.markDate,
      this.timeOffset
    );
    this.dynamicDialogRef.close(this.mark);
  }

  private getTimeOffset(timeZone: string) {
    const zone = timeZone.split("UTC ")[1];
    return Number(zone) * 60 * 60 * 1000;
  }

  private getConvertedDate(originalDate: number, timeZone: string) {
    if (!originalDate) {
      return new Date();
    }
    // const currentOffset = originalDate.getTimezoneOffset();
    // const currentOffsetInMilliseconds = currentOffset * 60 * 1000;
    // const offsetInMilliseconds = this.getTimeOffset(timeZone);
    // return new Date(originalDate.getTime() + offsetInMilliseconds + currentOffsetInMilliseconds);
    const browserOffset = new Date().getTimezoneOffset();
    const offsetHours = parseInt(timeZone.slice(0, 3), 10);
    const offsetMinutes = parseInt(timeZone.slice(0, 5), 10) % 100;
    const raceOffsetMinutes = offsetHours * 60 + offsetMinutes;
    const delta = raceOffsetMinutes + browserOffset;
    const localTime = originalDate + delta * 60000;
    return new Date(localTime);
  }

  private getOriginalDate(convertedDate: Date, timeZone: string) {
    // const currentOffset = convertedDate.getTimezoneOffset();
    // const currentOffsetInMilliseconds = currentOffset * 60 * 1000;
    // const offsetInMilliseconds = this.getTimeOffset(timeZone);
    // return new Date(convertedDate.getTime() - offsetInMilliseconds - currentOffsetInMilliseconds);
    const browserOffset = new Date().getTimezoneOffset();
    const offsetHours = parseInt(timeZone.slice(0, 3), 10);
    const offsetMinutes = parseInt(timeZone.slice(0, 5), 10) % 100;
    const raceOffsetMinutes = offsetHours * 60 + offsetMinutes;
    const delta = raceOffsetMinutes + browserOffset;
    const originalTime = convertedDate.getTime() - delta * 60000;
    return new Date(originalTime);
  }
}
